const AnalyticsAPI = (key) => {
  const analytics = window.analytics = window.analytics || [];
  if(!analytics.initialize){
    if(analytics.invoked){
      window.console && console.error && console.error("Segment snippet included twice.");
    } else {
      analytics.invoked = true;
      analytics.methods = [
        "trackSubmit",
        "trackClick",
        "trackLink",
        "trackForm",
        "pageview",
        "identify",
        "reset",
        "group",
        "track",
        "ready",
        "alias",
        "page",
        "once",
        "off",
        "on"
      ];
      analytics.factory = (t) => {
        return function(){
          const e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        }
      };
      for(let t = 0; t < analytics.methods.length; t++){
        const e = analytics.methods[t];
        analytics[e] = analytics.factory(e);
      }
      analytics.load = (t) => {
        const e = document.createElement("script");
        e.type="text/javascript";
        e.async=!0;
        e.src=("https:" === document.location.protocol?"https://":"http://")+"segment-cdn.pitchhub.com/analytics.js/v1/"+t+"/analytics.min.js";
        const n = document.getElementsByTagName("script")[0];
        n.parentNode.insertBefore(e,n)
      };
      analytics.SNIPPET_VERSION="3.1.0";
      analytics.load(key);
      // Make sure to remove any calls to `analytics.page()`!
    }
  }
};

export default AnalyticsAPI;